<template>
<div>
    <Header />
    <main>
        <section class="bg-secondary position-relative pt-xl-8 pb-3">
            <span>
                <svg class="position-absolute bottom-0 start-0" viewBox="0 0 1920 193.5" style="enable-background:new 0 0 1920 193.5;" xml:space="preserve">
                    <path class="fill-body" d="M556,116.1c-184.7-78.7-447.6-32.8-556,0v77.4h1920V0c-56.4,35.6-132.2,69.4-285.5,38 C1481.2,6.6,1333-21.5,1125.7,55.4C1012.7,108.5,740.7,194.8,556,116.1z" />
                </svg>
            </span>

            <div class="container position-relative pt-4 pt-sm-5">
                <div class="row mb-5 mb-md-7">
                    <div class="col-lg-6 col-xl-5">
                        <h1 class="fw-bold display-6 mb-3 mb-sm-4 mb-lg-0">
                            {{ $t('home.sectionTitle') }} <span class="text-primary-grad">Blogs</span>
                        </h1>
                    </div>
                    <div class="col-lg-5 ms-auto">
                        <p class="mb-0">{{ $t('home.sectionDescription') }}</p>
                        <div class="bg-body rounded-pill position-relative z-index-2 p-1 mt-4">
                            <form class="input-group align-items-center">
                                <input class="form-control bg-transparent border-0 me-1" type="email" :placeholder="$t('home.research')">
                                <button type="button" class="btn btn-dark btn-round rounded-circle lh-1 mb-0 me-2">
                                    <i class="bi bi-search"></i>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="row g-4 mb-n8">
                    <div class="col-lg-6">
                        <article class="card card-img-scale overflow-hidden rounded-4">
                            <img src="/assets/images/photo_2025-03-13_22-59-57.jpg" class="img-scale" alt="blog-img">
                            <div class="bg-overlay bg-dark opacity-3"></div>
                        </article>
                    </div>
                    <div class="col-lg-6">
                        <article class="card card-img-scale overflow-hidden rounded-4">
                            <img src="/assets/images/photo_2025-03-13_22-59-49.jpg" class="img-scale" alt="blog-img">
                            <div class="bg-overlay bg-dark opacity-3"></div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
        <LatestArticles />
        <TopWriter />
        <BlogSlider />
    </main>
    <Footer />
</div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import BlogSlider from '@/components/BlogSlider.vue'
import LatestArticles from '@/components/LatestArticles.vue'
import TopWriter from '@/components/TopWriter.vue'

export default {

    components: {
        Header,
        Footer,
        BlogSlider,
        LatestArticles,
        TopWriter
    }
};
</script>

<style scoped>

</style>
